import logo from './logo.svg';
import './App.css';

import React, { useState, useEffect, ChangeEventHandler, ChangeEvent, SyntheticEvent, KeyboardEvent, createContext } from "react";
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import Checkbox from "@mui/material/Checkbox";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Slider from '@mui/material/Slider';
import Switch from '@mui/material/Switch';
import TextField from '@mui/material/TextField';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import Icon from '@mui/material/Icon';
import WifiIcon from '@mui/icons-material/Wifi';
import WifiOffIcon from '@mui/icons-material/WifiOff';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import Webcam from "react-webcam";

import axios from 'axios';
import { Buffer } from 'buffer';
import socketio from "socket.io-client";

export const sio = socketio();

function Booth() {
  const [base64Link1, setBase64Link1] = useState('');
  const [base64Link2, setBase64Link2] = useState('');
  const [base64Link3, setBase64Link3] = useState('');
  const [statusText, setStatusText] = useState('Waiting for button press...');

  sio.on("buttons", data => {
    console.log(data)
  });

  sio.on("status", data => {
    console.log(data)
    setStatusText( data.msg );
  });

  return (
    <Box sx={{textAlign: 'center'}}>
      <Grid container direction="row" spacing={2} justifyContent="space-between" sx={{padding: 2}}>
        <Grid item>
          <Typography variant="h5" component="h1" color="primary">
            Photo Booth
          </Typography>
          </Grid>
      </Grid>

      <Grid container spacing={3}>
        <Grid item  xs={2} md={2}>
          <Box sx={{margin: 2}}>
            {/* <Typography variant="h6" component="h2" color="primary">
              Previous Images
            </Typography> */}
            {/* <img src={`data:image/jpeg;charset=utf-8;base64,${base64Link1}`} height="150"/>
            <img src={`data:image/jpeg;charset=utf-8;base64,${base64Link2}`} height="150"/>
            <img src={`data:image/jpeg;charset=utf-8;base64,${base64Link3}`} height="150"/> */}
            <Typography variant="body1" component="h2" color="primary">
              Mit einem Druck auf die kabelgebundene Fernbedienung wird ein Selbstauslöser mit 5 Sekunden gestartet.
              Die Bilder werden nach der Feier sortiert und dann bereitgestellt.
            </Typography>
          </Box>
        </Grid>

        <Grid item  xs={8} md={8}>
          <Card>{/* variant="outlined" */}
          <Webcam
                  width='800'
                  // height='600'
                  // style={{ transform: 'rotate(180deg)' }}
                  />
          </Card>
        </Grid>

        <Grid item  xs={2} md={2}>
          <Box sx={{margin: 2}}>
            <Typography variant="h6" component="h2" color="primary">
              Status
            </Typography>
            <Typography variant="body1" component="h2" color="primary">
              {statusText}
            </Typography>
          </Box>
        </Grid>

      </ Grid>
    </Box>
  );
}

export default Booth;
